import { render, staticRenderFns } from "./DeliveryOrderHtmlTemplate.vue?vue&type=template&id=4b5e9dd2&scoped=true"
import script from "./DeliveryOrderHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderHtmlTemplate.vue?vue&type=style&index=0&id=4b5e9dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e9dd2",
  null
  
)

export default component.exports